module.exports = __WEBPACK_EXTERNAL_MODULE_247__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 247
// module chunks = 0